import React from 'react';
import {motion} from 'framer-motion';

const sectionFadeIn = {
  initial: {opacity: 0, y: 30},
  whileInView: {opacity: 1, y: 0},
  transition: {duration: 0.7, ease: 'easeInOut'},
  viewport: {once: true, amount: 0.2},
};

export default function SolutionSection() {
  return (
    <motion.section
      className="solution-section"
      initial="initial"
      whileInView="whileInView"
      transition={sectionFadeIn.transition}
      viewport={sectionFadeIn.viewport}
    >
      <div className="container">
        <motion.div className="section-content">
          <motion.h2 {...sectionFadeIn}>
            💫 Just a Homemaker vs Respected Life Coach
          </motion.h2>

          <motion.p
            className="solution-intro"
            {...sectionFadeIn}
            transition={{delay: 0.1, ...sectionFadeIn.transition}}
          >
            You're not stuck because you lack skills. <strong>You're stuck because you don't have a clear path to turn your emotional intelligence into a respected career.</strong> Neenga capable ah irukkeenga, but system theriyala. It's time to stop being "just a homemaker" and start building a life coach identity with flexibility, respect, and income.
          </motion.p>

          <div className="comparison-table">
            <motion.div
              className="old-way"
              {...sectionFadeIn}
              transition={{delay: 0.2, ...sectionFadeIn.transition}}
            >
              <h3>❌ Without a System (Society's Label)</h3>
              <ul>
                <li>Known only as "Amma" or "Akka" — no personal identity</li>
                <li>Help everyone for free, but never get paid</li>
                <li>Financially dependent — asking for money hurts self-respect</li>
                <li>No time flexibility — family always comes first</li>
                <li>Skills and experience stay unrecognized</li>
                <li>Society says "just a housewife" — no professional respect</li>
                <li>Dreams stay dreams — never become reality</li>
              </ul>
            </motion.div>

            <motion.div
              className="new-way"
              {...sectionFadeIn}
              transition={{delay: 0.4, ...sectionFadeIn.transition}}
            >
              <h3>✅ With a Life Coach System (Your Own Identity)</h3>
              <ul>
                <li>Build a respected professional identity — people know you as a coach</li>
                <li>Turn your natural emotional intelligence into paid sessions</li>
                <li>Financial independence — earn with dignity and confidence</li>
                <li>Work around family time — completely flexible schedule</li>
                <li>Your life experience becomes your biggest strength</li>
                <li>Society respects you as a professional — not "just" anything</li>
                <li>Purpose + income + flexibility — all three together</li>
              </ul>
            </motion.div>
          </div>

          <motion.p
            style={{
              textAlign: 'center',
              fontSize: '1.2rem',
              marginTop: '2rem',
              color: '#ffffff',
              fontWeight: '600',
            }}
            {...sectionFadeIn}
            transition={{delay: 0.6, ...sectionFadeIn.transition}}
          >
            Ungalukum adhe system irundha, respect + income + flexibility — all possible. 💫
          </motion.p>
        </motion.div>
      </div>
    </motion.section>
  );
}